import React from 'react'

const Visorpdf = ({ urlpdf }) => {
    const googleUrl = "https://docs.google.com/viewer?url=" + urlpdf + "&embedded=true"
    return (

        <>
            <div className='w-full sm:w-[75%] bg-white mx-auto p-2 rounded-xl'>
                <div className='w-{90%} mx-auto items-center shadow-xl'>
                    <object data={urlpdf} type="application/pdf" width="100%" height="600px">
                        <iframe src={googleUrl} width="100%" height="600px">
                        </iframe>
                    </object>
                </div>
            </div>
            <br />
        </>
    );
}

export default Visorpdf;